export default "__VITE_ASSET__DSdgR_F1__"